<template>
  <div class="d-flex justify-end" :class="$root.isMobile ? 'flex-column' : ''">
    <v-btn
      depressed
      tile
      outlined
      color="primary"
      :class="$root.isMobile ? 'mt-3' : 'ml-3'"
      :width="$root.isMobile ? '100%' : '140px'"
      @click="$router.push('/')"
    >
      Close
    </v-btn>
    <template v-if="isCreate">
      <v-btn
        v-if="isAdmin || isDispatcher || isDataEntry || isDataEntryAndDispatcher"
        tile
        depressed
        class="primary"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="$emit('addRecord', false)"
      >
        Add Record
      </v-btn>
      <v-btn
        v-if="isAdmin || isDispatcher || isDataEntry || isDataEntryAndDispatcher"
        tile
        depressed
        class="success"
        @click="$emit('addRecord', true)"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
      >
        Send Text
      </v-btn>
    </template>
    <template v-else>
      <template>
        <v-btn
          v-if="isDelete && isAdmin"
          tile
          depressed
          class="error"
          :class="$root.isMobile ? 'mt-3' : 'ml-3'"
          :width="$root.isMobile ? '100%' : '140px'"
          @click="remove()"
        >
          Delete
        </v-btn>
        <v-btn
          v-if="isAdmin || isDispatcher || isDataEntryAndDispatcher"
          depressed
          tile
          outlined
          color="success"
          :class="$root.isMobile ? 'mt-3' : 'ml-3'"
          @click="resend()"
          :width="$root.isMobile ? '100%' : '140px'"
        >
          RESEND
        </v-btn>
        <v-btn
          v-if="isAdmin || isDispatcher || isDataEntryAndDispatcher"
          tile
          depressed
          class="primary"
          :class="$root.isMobile ? 'mt-3' : 'ml-3'"
          :width="$root.isMobile ? '100%' : '140px'"
          @click="$emit('confirmJob')"
        >
          Confirm Job
        </v-btn>
      </template>
      <v-btn
        tile
        v-if="isAdmin || isDispatcher || isDataEntryAndDispatcher"
        depressed
        class="success"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="$emit('updateCustomer')"
      >
        Update
      </v-btn>
    </template>
  </div>
</template>

<script>
import customerMixins from "../../../assets/js/customer.mixins";
import { customers, functions } from "../../../assets/js/firebase";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [customerMixins],
  computed: {
    isDelete() {
      let { status } = this.item;
      return status == 0 || status == 4;
    },
  },
  methods: {
    async remove() {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to Delete this customer",
        onConfirm: async () => {
          let { params } = vm.$route;
          let { id } = params;
          try {
            vm.$root.loader = true;
            await customers.doc(id).delete();
            vm.$root.loader = false;
            vm.$root.alert("Customer removed successfully");
          } catch (error) {
            vm.$root.loader = true;
            vm.$root.alert(error.message);
          }
        },
      });
    },
    async resend() {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure, Do you want to resend sms?",
        onConfirm: async () => {
          try {
            vm.$root.loader = true;
            let { data } = await functions.httpsCallable("resendSMS")({
              id: vm.customerId,
              updated_at: this.date,
            });
            vm.$root.loader = false;
            if (data.status) {
              vm.$root.alert(data.message);
            } else {
              vm.$root.alert("SMS has been submitted to successfully");
            }
          } catch (error) {
            vm.$root.loader = true;
            vm.$root.alert(error.message);
          }
        },
      });
    },
  },
};
</script>

<style></style>
